import Model from '@/models/Model.js';

export default class CourseLogEntry extends Model {
    static entity = 'course_log_entries';

    static modelName = 'CourseLogEntry';

    static fields() {
        return {
            id: this.attr(null),
            course_id: this.attr(null),
            type: this.attr(null),
            description: this.attr(null),
            loggable_id: this.attr(null),
            loggable_type: this.attr(null),
            loggable_type_entity: this.attr(null),

            ...super.fields(),

            creator: this.belongsTo('users', 'created_by'),
            editor: this.belongsTo('users', 'updated_by'),

            course: this.belongsTo('courses', 'course_id'),
            loggable: this.morphTo('loggable_id', 'loggable_type_entity'),
        };
    }
}
